import {event,event4} from "../analytics";
import {getFormCategory} from "./form"
import {getLocalStorageInfo} from "./pre-fill/local-storage";

class FormAnalytics {
	static init(drForm) {
		drForm._fieldsHistory = [];
		drForm._formStart = null;
		FormAnalytics.formFieldsHistory(drForm);
		FormAnalytics.abandonedFormsTracking(drForm);
	}

	/**
	 *
	 * @param obj
	 * @returns {{}}
	 */
	static lowercaseKeys(obj) {
		var key, keys = Object.keys(obj);
		var n = keys.length;
		var newobj = {}
		while (n--) {
			key = keys[n];
			newobj[key.toLowerCase()] = obj[key];
		}
		return newobj;
	}

	/**
	 * Get user details in IS format
	 * @returns {{user: {attributes: {}}}}
	 */
	static getUserAttributes() {
		// lowercase keys to make it consistent
		let info = FormAnalytics.lowercaseKeys(getLocalStorageInfo());
		// replace title to jobtitle to match Interaction Studio format
		info.jobtitle = info.title;
		delete info.title;

		return {"user": {_id: info.email, "attributes": info}};
	}

	static onFormSuccess(drForm) {
		FormAnalytics.storeDataForAnalytics(drForm);
		let category = getFormCategory(drForm);
		let label = drEvents.hasOwnProperty('post_type') ? drEvents.post_type : 'page';
		event('Form submission', category, label, null, FormAnalytics.getUserAttributes());
        event4('form_submission', [
                {'key': 'formCategory', 'value': category},
                {'key': 'postType', 'value': label},
            ]
        );
		FormAnalytics.finishedFormsTracking(drForm, category);
	}

	static finishedFormsTracking(drForm, category) {
		FormAnalytics.setFormFieldsHistory(drForm, 'Form submitted');
		let fields = drForm._fieldsHistory.join(' > ');
		event('Form finished', category, fields, FormAnalytics.getFormTime(drForm));
        event4('form_finished', [
                {'key': 'formCategory', 'value': category},
                {'key': 'fields', 'value': fields},
                {'key': 'time', 'value': FormAnalytics.getFormTime(drForm)},
            ]
        );
		FormAnalytics.clearFormFieldsHistory(drForm);
	}

	static abandonedFormsTracking(drForm) {
		window.addEventListener('beforeunload', () => {
			if (drForm._fieldsHistory.length) {
				let category = drForm.dataset['category'];
				let fields = drForm._fieldsHistory.join(' > ');
				event('Form abandoned', category, fields, FormAnalytics.getFormTime(drForm));
                event4('form_abandoned', [
                        {'key': 'formCategory', 'value': category},
                        {'key': 'fields', 'value': fields},
                        {'key': 'time', 'value': FormAnalytics.getFormTime(drForm)},
                    ]
                );
			}
		});
	}

	static formFieldsHistory(drForm) {
		// Listen to form fields change
		let form = drForm.querySelector('form');
		if(form) {
			form.addEventListener('change', (e) => {
				FormAnalytics.setFormFieldsHistory(drForm, FormAnalytics.getFieldName(drForm, e.target));
			});
			// Listen to email change (for some reason this field has no change event)
			let emailField = form.querySelector('.calc-email');
			if (emailField) {
				emailField.addEventListener('input', (e) => {
					FormAnalytics.setFormFieldsHistory(drForm, FormAnalytics.getFieldName(drForm, e.target));
				});
			}
			// Listen to submit button click
			form.querySelector('.primaryAction').addEventListener('click', (e) => {
				FormAnalytics.setFormFieldsHistory(drForm, 'Submit');
			});
			// Listen to validation errors
			form.addEventListener('dr.validated', (e) => {
				let validationInfo = '[validation error: %s]';
				let invalidFields = [];
				form.querySelector('.mktoInvalid').forEach((item) => {
					let field = item.name ? item : item.closest('.mktoFieldWrap').querySelector('.mktoField');
					if (field && field.name) {
						invalidFields.push(field.name);
					}
				});
				if (invalidFields.length) {
					FormAnalytics.setFormFieldsHistory(drForm, validationInfo.replace('%s', invalidFields.join(', ')));
				}
			});
		}
	}

	static setFormFieldsHistory(drForm, fieldName) {
		let isIndexInHistory = drForm._fieldsHistory.lastIndexOf(fieldName);
		let lastItemIndex = drForm._fieldsHistory.length - 1;
		if (isIndexInHistory === -1 || isIndexInHistory < lastItemIndex) {
			drForm._fieldsHistory.push(fieldName);
		}
		FormAnalytics.setFormStart(drForm);
	}

	static clearFormFieldsHistory(drForm) {
		drForm._fieldsHistory = [];
	}

	static setFormStart(drForm) {
		if (drForm._formStart === null) {
			drForm._formStart = new Date();
		}
	}

	static getFormTime(drForm) {
		let formTime = 0;
		if (drForm._formStart !== null) {
			let formEnd = new Date();
			let timeDiff = (formEnd.getTime() - drForm._formStart.getTime()) / 1000;	// in seconds
			formTime = Math.abs(Math.round(timeDiff))
		}

		return formTime;
	}

	static getFieldName(drForm, field) {
		return drForm.querySelector('[for="' + field.getAttribute('id') + '"]').textContent;
	}


	static storeDataForAnalytics(drForm) {
		// Maybe we need ot use .validate-email instead?
		let emailInput = drForm.querySelector('form .calc-email');
		if (emailInput) {
			// User ID for Snowplow analytics, this data is used in GTM
			localStorage.setItem('dr_user_email', emailInput.value);
		}
	}
}

export default FormAnalytics;
